<div @fadeInAnimation>
  <div
    class="order-page-title"
    id="top"
  >
    <div class="content">
      <eps-button
        class="edit-button"
        (buttonClick)="cancelClicked()"
        label="SHARED.BUTTONS.BACK"
        *ngIf="panelStatus.backButton.isVisible"
      ></eps-button>

      <app-title
        *ngIf="mode.state !== 'view' && !mode.createTemplate && !mode.editTemplate"
        title="SHARED.BUTTONS.CREATE"
        subtitle="RELOCATIONS.DETAILS.TITLE"
      ></app-title>
      <app-title
        *ngIf="mode.state !== 'view' && (mode.createTemplate || mode.editTemplate)"
        [title]="mode.editTemplate ? 'SHARED.BUTTONS.EDIT' : 'SHARED.BUTTONS.CREATE'"
        subtitle="TEMPLATES.DETAILS.TITLE_RELOCATION"
      ></app-title>

      <div
        class="action_buttons"
        *ngIf="mode.state === 'view'"
      >
        <div>
          <eps-button
            (buttonClick)="copyRelocation()"
            label="SHARED.BUTTONS.COPY"
          ></eps-button>
        </div>
      </div>
    </div>
  </div>

  <div class="row filter-container">
    <div class="col-12 col-md-12 col-lg-9 filter-container-inner">
      <div
        id="step-delivery"
        class="order-create-title-bar"
      >
        <div
          class="order-create-title-bar-header title-action-bar"
          [ngClass]="{ activated: panelStatus.delivery.isEdit }"
        >
          <div class="order-create-title">
            <i
              class="fa fa-truck"
              aria-hidden="true"
            ></i>
            <b>1&nbsp;&nbsp;{{ 'ORDERS.DELIVERY.TITLE' | translate }}</b> {{ 'ORDERS.DELIVERY.SUBTITLE' | translate }}
          </div>
          <eps-button
            *ngIf="(panelStatus.delivery.isEditable || mode.editWindow === 'detail' || mode.editWindow === 'planning') && !panelStatus.busy && !disableButtons"
            (click)="editDeliveryMethodClicked()"
            label="SHARED.BUTTONS.EDIT"
          ></eps-button>
        </div>

        <app-relocation-edit-delivery
          [definitions]="definitions"
          [relocationDetail]="relocationDetail"
          [deliveryMethod]="relocationDetail.deliveryMethod"
          [panelStatus]="panelStatus.delivery"
          [locations]="allowedLocations"
          (cancelClicked)="cancelClicked()"
          (nextClicked)="setDeliveryMethod($event)"
          (formValidChanged)="formValidChanged('delivery', $event)"
        >
        </app-relocation-edit-delivery>
      </div>

      <div class="order-create-title-bar">
        <div
          class="order-create-title-bar-header title-action-bar"
          [ngClass]="{ activated: panelStatus.detail.isEdit }"
        >
          <div
            id="step-details"
            class="order-create-title"
          >
            <i
              class="fa fa-file-o"
              aria-hidden="true"
            ></i>
            <b>2&nbsp;&nbsp;{{ 'RELOCATIONS.DETAILS.TITLE' | translate }}</b> {{ 'RELOCATIONS.DETAILS.SUBTITLE' | translate }}
          </div>
          <eps-button
            *ngIf="(panelStatus.detail.isEditable || mode.editWindow === 'planning') && !panelStatus.busy && !disableButtons"
            (click)="editDetailClicked()"
            label="SHARED.BUTTONS.EDIT"
          ></eps-button>
        </div>
      </div>
      <app-relocation-edit-detail
        *ngIf="panelStatus.detail.isVisible"
        [definitions]="definitions"
        [editMaterial]="mode.material"
        [relocationDetail]="relocationDetail"
        [panelStatusMaterial]="panelStatus.material"
        [panelStatus]="panelStatus.detail"
        [materialTypes]="materialTypes"
        (cancelClicked)="cancelClicked()"
        (nextClicked)="saveDetails()"
        (saveMaterialClicked)="saveMaterial($event)"
        (removeMaterialClicked)="removeMaterial($event)"
        (startEditMaterialClicked)="editMaterial($event)"
        (formValidChanged)="formValidChanged('detail', $event)"
      >
      </app-relocation-edit-detail>

      <!-- PLANNING -->
      <div class="order-create-title-bar">
        <div
          class="order-create-title-bar-header title-action-bar"
          [ngClass]="{ activated: panelStatus.planning.isEdit }"
        >
          <div
            id="step-planning"
            class="order-create-title"
            *ngIf="!mode.createTemplate && !mode.editTemplate"
          >
            <i
              class="fa fa-calendar-check-o"
              aria-hidden="true"
            ></i>
            <b>3&nbsp;&nbsp;{{ 'RELOCATIONS.PLANNING.TITLE' | translate }}</b> {{ 'RELOCATIONS.PLANNING.SUBTITLE' | translate }}
          </div>
          <div
            class="order-create-title"
            *ngIf="mode.createTemplate || mode.editTemplate"
          >
            <i
              class="fa fa-calendar-check-o"
              aria-hidden="true"
            ></i>
            <b>3&nbsp;&nbsp;{{ 'ORDERS.NO_PLANNING.TITLE' | translate }}</b> {{ 'ORDERS.NO_PLANNING.SUBTITLE' | translate }}
          </div>
          <eps-button
            *ngIf="panelStatus.planning.isEditable && !panelStatus.busy"
            (click)="editPlanningClicked()"
            [disabled]="panelStatus.busy || panelStatus.planning.opening || disableButtons"
            [busy]="panelStatus.planning.opening"
            label="SHARED.BUTTONS.EDIT"
          ></eps-button>
        </div>
      </div>
      <app-relocation-edit-planning
        *ngIf="panelStatus.planning.isVisible"
        [authorization]="authorization"
        [relocationDetail]="relocationDetail"
        [panelStatus]="panelStatus.planning"
        [availableLoadingDates]="availableLoadingDates"
        (cancelClicked)="cancelClicked()"
        (nextClicked)="savePlanning($event)"
        (formValidChanged)="formValidChanged('planning', $event)"
      >
      </app-relocation-edit-planning>
    </div>
  </div>

  <div class="col-12 col-md-12 col-lg-9 buttons">
    <eps-button
      type="link"
      *ngIf="showCancel()"
      (buttonClick)="!disableButtons && cancel()"
      label="SHARED.BUTTONS.CANCEL"
    ></eps-button>
    <eps-button
      [disabled]="disableButtons || !formsAreValid.all"
      [busy]="disableButtons"
      (buttonClick)="!disableButtons && panelStatus.submitButton.isEnabled && formsAreValid.all && submitClicked()"
      *ngIf="showSubmit()"
      [submit]="nextOnEnterPressed$ | async"
      label="SHARED.BUTTONS.SUBMIT"
    ></eps-button>
  </div>
</div>
